export const configHbA1c = {
  type: "bar",
  plugins: {
    title: {
      display: true,
      text: "HbA1c - Données capteur",
      padding: 20,
    },
    legend: {
      position: "bottom",
    },
    datalabels: {
      align: "top",
      offset: -5,
      backgroundColor: function (context) {
        return "#24335D";
      },
      borderRadius: 4,
      color: "white",
      font: {
        weight: "bold",
      },
      //formatter: Math.round,
      padding: 6,
    },
  },
  responsive: true,
  scales: {
    x: {
      stacked: true,
    },
    ya: {
      type: "linear",
      display: false,
      position: "right",
      // grid line settings
      grid: {
        drawOnChartArea: true,
      },
      suggestedMin: 0,
      suggestedMax: 20,
    },
    yb: {
      type: "linear",
      display: true,
      position: "left",
      suggestedMax: 100, // minimum will be 0, unless there is a lower value.
      suggestedMin: 0, // minimum will be 0, unless there is a lower value.
      // OR //
      beginAtZero: true, // minimum value will be 0.
      grid: {
        drawOnChartArea: true,
      },
    },
    yc: {
      type: "linear",
      display: true,
      position: "right",
      // grid line settings
      grid: {
        drawOnChartArea: true,
      },
      suggestedMax: 20, // minimum will be 0, unless there is a lower value.
      suggestedMin: 0, // minimum will be 0, unless there is a lower value.
    },
  },
};

export const dataConfigHbA1c = (data) => ({
  labels: data.labels,
  datasets: [
    {
      label: "HbA1c %",
      data: data.hba1c,
      borderColor: "#24335D",
      backgroundColor: "#24335D",
      yAxisID: "ya",
      type: "line",
      datalabels: { display: true },
    },
    {
      label: "% Données capteur",
      data: data.tc,
      borderColor: "#52BDC8",
      backgroundColor: "#52BDC8",
      yAxisID: "yb",
      type: "line",
      datalabels: { display: false },
    },
    {
      label: "Moyenne du nombre de glycémies",
      data: data.moyglyc,
      backgroundColor: "#E8477D",
      yAxisID: "yc",
      type: "bar",
      datalabels: { display: false },
    },
  ],
});
